(function () {
  var bodyClass = 'tambur-product-panel-open';

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.tambur-product-drawer.is-open')) {
      document.body.classList.remove(bodyClass);
    }
  }

  function openPanel(id) {
    // Atelier unified panel handles specs|shipping|returns itself.
    if (document.querySelector('[data-atelier-panel]')) return;
    document.querySelectorAll('.tambur-product-drawer.is-open').forEach(closePanel);
    var panel = document.querySelector('[data-product-panel="' + id + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add(bodyClass);
    var dialogPanel = panel.querySelector('.tambur-product-drawer__panel');
    if (dialogPanel) dialogPanel.focus();
  }

  function getCloseIcon(btn) {
    return btn.querySelector('.tambur-product-drawer__close-icon') || btn.querySelector('svg');
  }

  function bindCloseSpin(btn, onFinish) {
    if (!btn || btn.getAttribute('data-close-spin-bound') === 'true') return;
    btn.setAttribute('data-close-spin-bound', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-spinning')) return;
      var icon = getCloseIcon(btn);
      if (!icon) {
        onFinish();
        return;
      }
      var finished = false;
      function finishClose() {
        if (finished) return;
        finished = true;
        icon.removeEventListener('animationend', finishClose);
        clearTimeout(fallback);
        btn.classList.remove('is-spinning');
        onFinish();
      }
      var fallback = setTimeout(finishClose, 450);
      btn.classList.remove('is-spinning');
      void btn.offsetWidth;
      btn.classList.add('is-spinning');
      icon.addEventListener('animationend', finishClose);
    });
  }

  function init(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('.tambur-product-drawer__close').forEach(function (btn) {
      bindCloseSpin(btn, function () {
        closePanel(btn.closest('[data-product-panel]'));
      });
    });
  }

  if (!window.__tamburProductPanelsBound) {
    window.__tamburProductPanelsBound = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-product-panel-open]');
      if (openBtn) {
        e.preventDefault();
        openPanel(openBtn.getAttribute('data-product-panel-open'));
        return;
      }
      var closeTarget = e.target.closest('[data-product-panel-close]');
      if (closeTarget && !closeTarget.classList.contains('tambur-product-drawer__close')) {
        closePanel(closeTarget.closest('[data-product-panel]'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.tambur-product-drawer.is-open').forEach(closePanel);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
